export enum ConfrontationTypes {
  success,
  warning,
}
